const allProducts = [
  // Featured Products
  {
    id: 1,
    name: "Classic Round Glasses",
    category: "Round Frames",
    brand: "Ray-Ban",
    price: 120,
    image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 2,
    name: "Modern Square Eyewear",
    category: "Square Frames",
    brand: "Oakley",
    price: 150,
    image: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 3,
    name: "Aviator Sunglasses",
    category: "Sunglasses",
    brand: "Ray-Ban",
    price: 180,
    image: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 4,
    name: "Retro Cat Eye Glasses",
    category: "Cat Eye",
    brand: "Gucci",
    price: 135,
    image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 5,
    name: "Minimalist Metal Frame",
    category: "Metal Frames",
    brand: "Tom Ford",
    price: 110,
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 6,
    name: "Sporty Wrap Sunglasses",
    category: "Sports",
    brand: "Oakley",
    price: 160,
    image: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80",
  },
  // Recommended Products
  {
    id: 7,
    name: "Vintage Round Frames",
    category: "Round Frames",
    brand: "Warby Parker",
    price: 95,
    image: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 8,
    name: "Contemporary Square Glasses",
    category: "Square Frames",
    brand: "Prada",
    price: 140,
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 9,
    name: "Pilot Style Sunglasses",
    category: "Sunglasses",
    brand: "Ray-Ban",
    price: 165,
    image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 10,
    name: "Elegant Cat Eye Frames",
    category: "Cat Eye",
    brand: "Gucci",
    price: 125,
    image: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 11,
    name: "Sleek Metal Rim Glasses",
    category: "Metal Frames",
    brand: "Tom Ford",
    price: 105,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 12,
    name: "Adventure Sports Glasses",
    category: "Sports",
    brand: "Oakley",
    price: 175,
    image: "https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?auto=format&fit=crop&w=400&q=80",
  },
  // Additional Products
  {
    id: 13,
    name: "Kulangot",
    category: "Salt",
    brand: "Ray-Ban",
    price: 67,
    image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 14,
    name: "Tiktilaok Manok",
    category: "Sexbomb",
    brand: "Oakley",
    price: 78,
    image: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 15,
    name: "Very Nice",
    category: "Salt maalat",
    brand: "Gucci",
    price: 79,
    image: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 16,
    name: "Quake Overload",
    category: "Yezyow",
    brand: "Prada",
    price: 80,
    image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 17,
    name: "Kutu",
    category: "Black Kibal",
    brand: "Tom Ford",
    price: 129,
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 18,
    name: "Tuluk",
    category: "Betsin Maalat",
    brand: "Warby Parker",
    price: 142,
    image: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 19,
    name: "Balakubak",
    category: "Kibal Black",
    brand: "Ray-Ban",
    price: 170,
    image: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 20,
    name: "Pitaklan",
    category: "Round Frames",
    brand: "Oakley",
    price: 174,
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 21,
    name: "Burnikk",
    category: "Square Frames",
    brand: "Gucci",
    price: 240,
    image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 22,
    name: "Sipon Malapot",
    category: "Cat Eye",
    brand: "Prada",
    price: 250,
    image: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 23,
    name: "Buldit",
    category: "Metal Frames",
    brand: "Tom Ford",
    price: 674,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 24,
    name: "Kibal Batal",
    category: "Sports",
    brand: "Warby Parker",
    price: 89,
    image: "https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?auto=format&fit=crop&w=400&q=80",
  },
];

export default allProducts; 